/**
 * ComingSoon — placeholder used for route stubs whose features haven't
 * landed yet. Lets us preview the AppShell IA without building the full
 * surface of every nav target.
 */

import { PageHeader } from '@/components/PageHeader/PageHeader';
import { t } from '@/lib/i18n';
import styles from './ComingSoon.module.css';

interface ComingSoonProps {
  name: string;
  icon: string;
  description?: string;
}

export function ComingSoon({ name, icon, description }: ComingSoonProps) {
  return (
    <>
      <PageHeader title={name} subtitle={t('Coming soon')} />
      <div className={styles.body}>
        <div className={styles.icon} aria-hidden="true">
          {icon}
        </div>
        <h2 className={styles.headline}>{t('{name} is on the roadmap', { name })}</h2>
        <p className={styles.copy}>
          {description ??
            t(
              'This section is wired into the nav but the full surface lands in a future slice. The scaffolding around it (auth, layout, theming, design system) is already in place.',
            )}
        </p>
      </div>
    </>
  );
}
